import React, { useState } from "react";
import { Col_12_8_6_4 } from "../../../../components/col/Col_12_8_6_4";
import LabelValor from "../../../../components/label/LabelValor";
import { Modal, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { startUpdateServicio } from "../../../../context/actions/concesionariosActions";

export const Sucursal = () => {
  const [newValor, setNewValor] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();

  const { concesionariosServicio: c } = useSelector(
    (state) => state.concesionariosReducer
  );
  const s = c?.supervisoria;

  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => {
    setNewValor(s || "");
    setOpenModal(true);
  };

  const handleOk = () => {
    dispatch(startUpdateServicio({ supervisoria: newValor }, id));
    setOpenModal(false);
  };

  return (
    <>
      <Col_12_8_6_4>
        <LabelValor
          labelStyle={{ cursor: "pointer", textDecoration: "underline dotted" }}
          onClick={handleOpen}
          label="Supervisoría"
          valor={s || ""}
        />
      </Col_12_8_6_4>
      <Modal
        title="Supervisoría"
        onCancel={() => setOpenModal(false)}
        onOk={handleOk}
        open={openModal}
      >
        <Input
          value={newValor}
          onChange={(event) => setNewValor(event.target.value)}
          placeholder="Ingrese supervisoría"
          allowClear
        />
      </Modal>
    </>
  );
};
